import pdf from "../Res/KartikNaik-Resume.pdf";
export default function Header() {
  return (
    <header>
      <div className="profile-section">
        <div className="profile-info">
          <h1>Kartik Naik</h1>
          <p className="role">software Developement,Cloud & Devops Enthusiast</p>
          <p className="location">📍 Available for Remote/Hybrid/onsite Work</p>
          <a href={pdf}  target="_blank" 
            rel="noopener noreferrer"
           className="resume-download-btn">
            <i className="fa-solid fa-file-pdf"></i>
            <span>View Resume</span>
          </a>
        </div>
      </div>
      <nav>
        <a href="#about" className="nav-link">About</a>
        <span>/</span>
        <a href="#skills" className="nav-link">Skills</a>
        <span>/</span>
        <a href="#education" className="nav-link">Education</a>
        <span>/</span>
        <a href="#projects" className="nav-link">Projects</a>
        <span>/</span>
        <a href="#contact" className="nav-link">Contact</a>
      </nav>
    </header>
  );
}